import {Component} from 'react';
import './with-scroll-to-top.less';

export default function WithScrollToTop(OriginalComponent) {
	class WrappedComponent extends Component {
		componentDidMount() {
			this.scrollToTop();
		}

		componentDidUpdate() {
			this.scrollToTop();
		}

		scrollToTop() {
			if (window.pageYOffset) {
				window.scroll({
					behavior: 'auto',
					top: 0
				});
			}
		}

		render() {
			return (
				<OriginalComponent {...this.props} />
			);
		}
	}

	WrappedComponent.displayName = `WithScrollToTop(${OriginalComponent.displayName || OriginalComponent.name || 'Component'})`;

	return WrappedComponent;
}